import React, { useState } from "react";
import { ErrorMessage, useFormikContext } from "formik";

function CDInput({ label, name, placeholder, type, required }) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const formik = useFormikContext();

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const inputType =
    type === "password" && !isPasswordVisible ? "password" : "text";

  return (
    <div className="signup-input">
      <div className="label">
        {label}
        {required && <span className="required-asterisk">*</span>}
      </div>
      <div className="input-wrap tw-relative">
        <input
          {...formik.getFieldProps(name)}
          type={inputType}
          placeholder={placeholder}
        />
        {type === "password" && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3 tw-cursor-pointer"
          >
            {isPasswordVisible ? <h4>hide</h4> : <h4>show</h4>}
          </button>
        )}
      </div>
      <ErrorMessage name={name} component="div" className="error" />
    </div>
  );
}

export default CDInput;
